import React from 'react';
import QuadroSlider from './QuadroSlider';
import PropTypes from 'prop-types';
import { List } from 'immutable';

class HexaSlider extends QuadroSlider {
  constructor (props) {
    super(props);

    this.perPage = 6;
    this.perRow = 3;
    this.lastIndex = this.itemsCount - this.perPage;
  }

  render () {
    const {wrapperClassName, loading, btnLabel, btnLink} = this.props;
    const itemList = this.getItems();

    if (!loading && !itemList.length) {
      return null;
    }

    return (
      <div className={'hexa-slider ' + (wrapperClassName || '')}>
        <h3 className='hexa-slider__title'>{ this.props.title }</h3>

        <div className='hexa-slider__content'>
          { this.isShowArrow() && <button className='arrow icon-arrow-left-new' onClick={this.prevPage} key='left' /> }
          { this.isShowArrow() && <button className='arrow icon-arrow-right-new' onClick={this.nextPage} key='right' /> }

          <div className='hexa-slider__page_wrp'>
            <div className={'hexa-slider__page' + (loading ? ' loading' : '')}>
              {
                loading
                ? (
                  <div className='ajax-waiting-overlay'>
                    <div className='radial-progress'>
                      <div className='circle'>
                        <div className='fill' />
                      </div>
                    </div>
                  </div>
                )
                : itemList
              }
            </div>
          </div>
        </div>

        {
          btnLink && btnLabel && (
            <div className='footer'>
              <a className='btn-base btn-hollow' href={btnLink}>{btnLabel}</a>
            </div>
          )
        }
      </div>
    );
  }
}

HexaSlider.propTypes = {
  title: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  items: PropTypes.object,
  regionName: PropTypes.string.isRequired,
  dealType: PropTypes.string.isRequired,
  realtyType: PropTypes.string.isRequired,
  cardItemClass: PropTypes.func.isRequired,
  wrapperClassName: PropTypes.string,

  btnLabel: PropTypes.string,
  btnLink: PropTypes.string
};

HexaSlider.defaultProps = {
  wrapperClassName: null,
  loading: false,
  items: new List(),

  btnLabel: null,
  btnLink: null
};

export default HexaSlider;



// WEBPACK FOOTER //
// ./src/ui/Sliders/HexaSlider.jsx